import { render, staticRenderFns } from "./detail-edit.vue?vue&type=template&id=518b04aa"
import script from "./detail-edit.vue?vue&type=script&lang=js"
export * from "./detail-edit.vue?vue&type=script&lang=js"
import style0 from "./detail-edit.vue?vue&type=style&index=0&id=518b04aa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports